export const BOARD_SIZE = 9;
export const BOX_SIZE = 3;
export type Difficulty = 'easy' | 'medium' | 'hard';
export const DIFFICULTY_CLUES: Record<Difficulty, number> = {
  easy: 36,
  medium: 30,
  hard: 24,
};
export const COLORS = {
  cream: '#FFF8E7',
  ivory: '#F5E6D3',
  yellow: '#FFD93D',
  brown: '#8B7355',
  dark: '#2D2D2D',
};
export const SHADOWS = {
  soft: '6px 6px 12px rgba(139, 115, 85, 0.2), -6px -6px 12px rgba(255, 255, 255, 0.8)',
  pressed: 'inset 4px 4px 8px rgba(139, 115, 85, 0.2), inset -4px -4px 8px rgba(255, 255, 255, 0.8)',
  deep: '8px 8px 16px rgba(139, 115, 85, 0.25), -8px -8px 16px rgba(255, 255, 255, 0.9)',
};
export const LABELS = {
  title: 'Sudoku',
  startGame: 'Start Game',
  howToPlay: 'How to Play',
  difficulty: 'Difficulty',
  easy: 'Easy',
  medium: 'Medium',
  hard: 'Hard',
  bestTime: 'Best Time',
  noTime: '--:--',
  timer: 'Time',
  mistakes: 'Mistakes',
  notes: 'Notes',
  erase: 'Erase',
  undo: 'Undo',
  gotIt: 'Got It!',
  playAgain: 'Play Again',
  returnToLobby: 'Return to Lobby',
  congratulations: 'Congratulations!',
  gameOver: 'Game Over',
  newBestTime: 'New Best Time!',
  threeMistakes: '3 Mistakes Made',
  fastest: 'Fastest',
};
export const RULES = [
  'Fill the grid so each row contains 1-9 exactly once',
  'Each column must contain 1-9 exactly once',
  'Each 3x3 box must contain 1-9 exactly once',
  'Pre-filled numbers cannot be changed',
  'Tap a cell to select it',
  'Tap a number to fill the selected cell',
  'Use Notes mode to add pencil marks',
  'Erase clears the current cell',
  'Undo reverts your last action',
];